import { useEffect, useRef, useState } from 'react';

export const useHoverWithDelayedExit = (
	delay: number = 3000,
	initiallyHovered: boolean = false,
) => {
	const [isHovered, setIsHovered] = useState(initiallyHovered);
	const timerRef = useRef<number | null>(null);

	const handleMouseEnter = () => {
		if (timerRef.current) {
			window.clearTimeout(timerRef.current);
			timerRef.current = null;
		}
		setIsHovered(true);
	};

	const handleMouseLeave = () => {
		if (timerRef.current) {
			window.clearTimeout(timerRef.current);
		}
		timerRef.current = window.setTimeout(() => setIsHovered(false), delay);
	};

	useEffect(() => {
		if (initiallyHovered) {
			timerRef.current = window.setTimeout(() => setIsHovered(false), delay);
		}

		return () => {
			if (timerRef.current) {
				window.clearTimeout(timerRef.current);
			}
		};
	}, [delay, initiallyHovered]);

	return { isHovered, handleMouseEnter, handleMouseLeave };
};
